import type { User, BusinessUser } from '../../../types/usersDemo';

export const getStatusColor = (status: string): 'positive' | 'warning' | 'negative' | 'neutral' => {
  switch (status.toLowerCase()) {
    case 'active':
    case 'approved':
    case 'used':
      return 'positive';
    case 'pending':
    case 'processing':
      return 'warning';
    case 'inactive':
    case 'rejected':
    case 'declined':
    case 'expired':
      return 'negative';
    default:
      return 'neutral';
  }
};

export const getDrawerWidth = (activeTab: string): string => {
  switch (activeTab) {
    case 'profile': return '800px';
    case 'support': return '1000px';
    case 'activity': return '900px';
    case 'requests': return '1000px';
    default: return '800px';
  }
};

export const isBusinessContact = (contact: User | BusinessUser): contact is BusinessUser => {
  return 'business' in contact;
};

export const formatDateForTable = (dateString: string): string => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return dateString;
  }
  const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};


